import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonModule } from '../../notes/button/button.module';
import { MessageBannerModule } from '../../notes/message-banner/message-banner.module';
import { StatusModule } from '../../notes/status/status.module';

import { TooltipModule } from '../../notes/tooltip/tooltip.module';
import { SsoPaymentModule } from '../sso-payment/sso-payment.module';
import { PaymentCardBillNumberComponent } from './component/payment-card-bill-number/payment-card-bill-number.component';
import { PaymentCardComponent } from './payment-card.component';

@NgModule({
  declarations: [PaymentCardComponent, PaymentCardBillNumberComponent],
  imports: [
    CommonModule,
    RouterModule,
    StatusModule,
    ButtonModule,
    MessageBannerModule,
    TooltipModule,
    SsoPaymentModule,
  ],
  exports: [PaymentCardComponent, PaymentCardBillNumberComponent],
})
export class PaymentCardModule {}
